export default {"src":"/_next/static/media/full_logo.95c6bed5.svg","height":58,"width":136,"blurWidth":0,"blurHeight":0};